import { sharedUtils } from 'utils';

import type { Job } from 'clients/CampaignsClient/CandidateResponse';
import { Dictionary } from 'shared/legacy/contexts/LocalizationContext/types';
import { copyObject } from 'utils/shared';

export const getLastPositions = (jobs: Job[], length?: number) => {
  const sortedJobs = copyObject(jobs).reverse().slice(0, length);

  return sortedJobs.map(({ role, dates, company, description }) => {
    let name = role;
    if (company?.name) {
      name = `${role} @ ${company.name}`;
    }

    return {
      name,
      description,
      duration: sharedUtils.getDuration(dates) as any,
      startYear: dates.start?.year,
      endYear: getEndYear(dates.end?.year),
      fullDuration: sharedUtils.getFullDuration(dates) as any,
      companyName: company?.name,
      positionName: role,
    };
  });
};

export const getEndYear = (year: number | undefined) => (d: Dictionary) => {
  if (year) return year;

  return d.current;
};
